<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">Dedication</h1>
<p>I would like to dedicate this book to Jim Fuller, who supported me throughout my jockey career. Without whom I probably would have never gotten started as a jockey. He was my boss, my coach, and my agent on the track. He was like a father figure during that part of my life. He was always there for me no matter what. Jim would always say “go get ’em tiger” before I would go to the jock’s room. I still hear him saying that to me every time I go after a new dream like writing this book. So, thanks Jim. I hope you’re training some great horses in heaven!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?74dd61d6